import { useState } from "react";
import { Cable, RefreshCw, Wifi } from "lucide-react";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

export function NetworkConnectionsApp({ activeMachine, app, onRunCommand }: SimulatorAppSurfaceProps) {
  const [adapterName, setAdapterName] = useState("Ethernet0");
  const [ipAddress, setIpAddress] = useState("10.50.20.25");
  const [gateway, setGateway] = useState("10.50.20.1");
  const [dnsServer, setDnsServer] = useState("10.50.10.10");

  async function setStaticConfig() {
    await onRunCommand({
      appId: app.id,
      commandType: "NETWORK_SET_ADAPTER_CONFIG",
      capability: "network.adapter.write",
      label: "Set IPv4",
      payload: {
        adapterId: adapterName.toLowerCase(),
        adapterName,
        dhcp: false,
        gateway,
        ipAddress,
        ipv4: ipAddress,
        machineId: activeMachine,
        subnet: "255.255.255.0",
        subnetMask: "255.255.255.0"
      }
    });
  }

  async function setDns() {
    await onRunCommand({
      appId: app.id,
      commandType: "NETWORK_SET_DNS_SERVER",
      capability: "network.dns.write",
      label: "Set DNS",
      payload: {
        adapterId: adapterName.toLowerCase(),
        adapterName,
        dnsServer,
        dnsServers: [dnsServer],
        machineId: activeMachine
      }
    });
  }

  async function enableDhcp() {
    await onRunCommand({
      appId: app.id,
      commandType: "NETWORK_ENABLE_DHCP",
      capability: "network.adapter.write",
      label: "Enable DHCP",
      payload: {
        adapterId: adapterName.toLowerCase(),
        adapterName,
        machineId: activeMachine
      }
    });
  }

  return (
    <div className="fd-sim-app fd-sim-network">
      <aside className="fd-network-sidebar">
        <strong>Network Connections</strong>
        <button className="is-active" type="button"><Cable size={15} /> Ethernet</button>
        <button type="button"><Wifi size={15} /> Wi-Fi</button>
      </aside>
      <section className="fd-network-main">
        <header>
          <p>{activeMachine}</p>
          <h2>Ethernet Properties</h2>
        </header>
        <div className="fd-network-adapter">
          <span className="fd-network-card-icon"><Cable size={28} /></span>
          <div>
            <strong>{adapterName}</strong>
            <small>IPv4, DNS and DHCP configuration</small>
          </div>
        </div>
        <div className="fd-network-form-grid">
          <label>
            Adapter
            <input value={adapterName} onChange={(event) => setAdapterName(event.target.value)} />
          </label>
          <label>
            IPv4 address
            <input value={ipAddress} onChange={(event) => setIpAddress(event.target.value)} />
          </label>
          <label>
            Gateway
            <input value={gateway} onChange={(event) => setGateway(event.target.value)} />
          </label>
          <label>
            Preferred DNS
            <input value={dnsServer} onChange={(event) => setDnsServer(event.target.value)} />
          </label>
        </div>
        <div className="fd-network-actions">
          <button type="button" onClick={() => void setStaticConfig()}>Apply IPv4</button>
          <button type="button" onClick={() => void setDns()}>Apply DNS</button>
          <button type="button" onClick={() => void enableDhcp()}>Enable DHCP</button>
          <button
            type="button"
            onClick={() => {
              void onRunCommand({
                appId: app.id,
                commandType: "NETWORK_RELEASE_RENEW_LEASE",
                capability: "network.dhcp.write",
                label: "Renew lease",
                payload: { adapterId: adapterName.toLowerCase(), adapterName, machineId: activeMachine }
              });
            }}
          >
            <RefreshCw size={16} />
            Renew
          </button>
        </div>
      </section>
    </div>
  );
}
